/**
 * Small namespaced JSON store for view preferences (filters, search terms).
 *
 * The old app scattered a dozen bare localStorage keys — `filterObj`,
 * `appliedFilters`, `assignedToId`, `myTotalLessThan`, `invoicesSearchQuery` —
 * with no prefix, which is why logging out had to call `localStorage.clear()`
 * and take everything else with it. Every key here starts with `im.`.
 */

const PREFIX = "im.";

export function readPersisted(key, fallback = null) {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writePersisted(key, value) {
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* storage unavailable — preferences simply do not persist */
  }
}

export function removePersisted(key) {
  try {
    window.localStorage.removeItem(PREFIX + key);
  } catch {
    /* nothing to do */
  }
}
